/* ========================== */
/*     FEATURED PRODUCTS      */
/* ========================== */
featuredProdsSlider = {
    init: function () {
        if ($(".swiper--featured-prods").length > 0) {
            var swiper = new Swiper(".swiper--featured-prods", {
                slidesPerView: "auto",
                mousewheel: {
                    invert: false,
                    forceToAxis: true
                },
                navigation: {
                    nextEl: ".swiper--featured-prods .swiper-btn.btn--next",
                    prevEl: ".swiper--featured-prods .swiper-btn.btn--prev",
                },
            });
        }
    }
};

$(document).ready(function () {
    featuredProdsSlider.init();
});


